"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BufferFullnessExit;
(function (BufferFullnessExit) {
    BufferFullnessExit[BufferFullnessExit["REBUFFER_TO_STEADY"] = 10] = "REBUFFER_TO_STEADY";
    BufferFullnessExit[BufferFullnessExit["REBUFFER_TO_PANICMODE"] = 1] = "REBUFFER_TO_PANICMODE";
    BufferFullnessExit[BufferFullnessExit["STEADY_TO_PANICMODE"] = 4] = "STEADY_TO_PANICMODE";
    BufferFullnessExit[BufferFullnessExit["PANICMODE_TO_REBUFFER"] = 4] = "PANICMODE_TO_REBUFFER";
})(BufferFullnessExit || (BufferFullnessExit = {}));
exports.default = BufferFullnessExit;
//# sourceMappingURL=BufferFullnessExit.js.map